import { MoreHorizRounded } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";




const MenuButton = ({ options, handleOptionSelected }) => {

    // Menu code.
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const onMenuSelected = (option) => () => {
        setAnchorEl(null);
        handleOptionSelected(option)
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <div style={{ display: 'inline-block' }}>
            <button
                // id="basic-button"
                // aria-controls={menuOpen ? 'basic-menu' : undefined}
                // aria-haspopup="true"
                // aria-expanded={menuOpen ? 'true' : undefined}
                onClick={handleMenuClick}
            >
                <MoreHorizRounded style={{ verticalAlign: 'middle' }} />
            </button>
            <Menu
                // id="basic-menu"
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
            // slotProps={{
            //     list: {
            //         'aria-labelledby': 'basic-button',
            //     },
            // }}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} onClick={onMenuSelected(option)}>
                        <span className='menuOption'>
                            {option}
                        </span>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default MenuButton;



